<template>
  <div class="stencil-box">
    <div ref="imgBoxRef" class="img-box"></div>
    <a-tooltip placement="bottom">
      <template #title>{{ stencil.stencil.stencilName }}</template>
      <div
        ref="imgDropBoxRef"
        class="img-box drop-box"
        :data-stencilkey="stencil.stencilKey"
        :data-groupkey="stencil.groupKey"
      ></div>
    </a-tooltip>
  </div>
</template>

<script>
import { SVG } from "@svgdotjs/svg.js";

export default {
  name: "StencilItem",
  props: {
    stencil: {
      type: Object,
    },
  },
  mounted() {
    this.drawSvg();
  },
  methods: {
    drawSvg() {
      if (this.stencil.stencil.svg) {
        const imgDom = this.$refs.imgBoxRef;
        const imgDropDom = this.$refs.imgDropBoxRef;
        SVG(this.stencil.stencil.svg).addTo(imgDom).size(32, 32);
        SVG(this.stencil.stencil.svg).addTo(imgDropDom).size(32, 32);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.stencil-box {
  position: relative;
  width: 32px;
  height: 32px;
  > .img-box {
    width: 32px;
    height: 32px;
  }
  > .drop-box {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    cursor: move;
  }
}
</style>
